import { login as loginApi, logout as logoutApi } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    username: '',
    roleCode: ''
  }
}

const state = getDefaultState()

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, { username, roleCode }) {
    state.username = username
    state.roleCode = roleCode
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  async login({ commit }, userInfo) {
    const { username, password, captchaUuid, captchaCode } = userInfo
    const res = await loginApi({ username: username.trim(), password, captchaUuid, captchaCode })
    const { accessToken } = res.data
    commit('SET_TOKEN', accessToken)
    setToken(accessToken)
    return res
  },

  async getInfo({ commit, state }) {
    // For V1.0, decode basic info from token or use a stub
    // Will be replaced with a real /auth/info endpoint later
    commit('SET_USER_INFO', {
      username: 'admin',
      roleCode: 'SUPER_ADMIN'
    })
    return { username: 'admin', roleCode: 'SUPER_ADMIN' }
  },

  async logout({ commit }) {
    try {
      await logoutApi()
    } catch (e) {
      // ignore logout API errors
    }
    removeToken()
    resetRouter()
    commit('RESET_STATE')
  },

  resetToken({ commit }) {
    removeToken()
    commit('RESET_STATE')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
